const widgetCardStyle = (hover = false, clickable = false) => ({
  background: '#ffffff',
  borderLeft: '1px solid #e5e7eb',
  borderTop: '1px solid #e5e7eb',
  borderRadius: 0,
  padding: '1.25rem',
  width: '100%',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  alignItems: 'center', 
  textAlign: 'center',
  justifyContent: 'center',
  gap: '0.75rem',
  boxShadow: hover
    ? 'inset 0 0 0 9999px rgba(0, 0, 0, 0.015)'
    : 'none',
  transform: 'none',
  transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  cursor: clickable ? 'pointer' : 'default',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
})

const labelStyle = {
  fontSize: '1rem',
  fontWeight: 600,
  marginBottom: '0.25rem',
  color: '#0f172a',
}

const valueStyle = {
  fontSize: '2rem',
  fontWeight: 700,
  color: '#0f172a',
}

const footerStyle = {
  fontSize: '0.75rem',
  color: '#6b7280',
  marginTop: '0.25rem',
}

export { widgetCardStyle, labelStyle, valueStyle, footerStyle }
